export enum FormType {
  CreatePlanForm,
  UpdatePlanForm,
  ReviseContract,
}